
export enum DragObjectTypeEnum {
    SHIPMENT = 'application/shipment-object',
    ORDER = 'application/order-object'
}